// extracted by mini-css-extract-plugin
export default {"divPaginas":"HeaderProdutos_divPaginas__rkHU8"};